// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 179) return "main.css";
	// return url for filenames based on template
	return "" + "Calendar" + "-" + "1cfb340676eb40e81ef6" + ".css";
};